import { prettyDate, slotById } from "@/lib/studio";

export const ClassBookingResult = ({ result }) => {
  if (!result) {
    return (
      <div className="surface p-6 text-sm text-zinc-400 md:p-8" data-testid="class-booking-help">
        Every matching weekday session in the date range is booked for the class. Sessions that are already taken or on closed days are skipped and listed here.
      </div>
    );
  }
  return (
    <div className="surface p-6 md:p-8" data-testid="class-booking-result">
      <p className="font-display text-3xl font-bold text-white" data-testid="class-result-created">{result.created}</p>
      <p className="font-tech text-xs uppercase tracking-[0.2em] text-zinc-500">sessions booked</p>
      {result.skipped.length > 0 && (
        <div className="mt-6">
          <p className="mb-2 font-tech text-xs uppercase tracking-[0.2em] text-[#FF8C00]" data-testid="class-result-skipped-count">{result.skipped.length} skipped</p>
          <ul className="max-h-64 space-y-1 overflow-y-auto text-sm text-zinc-400" data-testid="class-result-skipped-list">
            {result.skipped.map((s) => (
              <li key={`${s.date}-${s.slot}`}>{prettyDate(s.date)} · {slotById(s.slot)?.time} — {s.reason}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
